
<template>
  <div class="justify-centered">
    
    <!-- <div class="title ml-2 white--text">{{oneForm.name}}</div> -->

    <v-col align="center" v-if="!chart_ready">
      <card-loading ></card-loading>
    </v-col>
    <v-row v-if="true && chart_ready" align="center" justify="center">
      <v-col cols="12" md="8" lg="6" >
        <v-container fluid>
          <v-row class="px-6" align="center" justify="space-around">
            <div class="white--text title mx-2" >
              Itens de {{oneForm.name}}
            </div>
            <v-spacer></v-spacer>
            <filter-items :indexFilter="getOneDoneForm"></filter-items>
          </v-row>

          <v-col cols="11">
            <v-card style="border-radius: 12px;" v-if="chart_ready">
              <v-card-text>
                <horizontal-bar v-if="chart_ready" :chart-data="chartData" :options="chartOptions"> </horizontal-bar>
              </v-card-text>
            </v-card>
          </v-col>
        </v-container>
      </v-col>
      <v-col cols="12" md="6" lg="6" v-if="false">
        <done-forms-table :headers_props="headers_data" :done_forms="oneForm.done_forms"></done-forms-table>
      </v-col>
    </v-row>


      <basic v-if="false"></basic>
  </div>
</template>

<script>
// COMPONENT NOT USED
import Api from '../../../api/index'
import { mapActions, mapState, mapGetters } from 'vuex'

import HorizontalBar from '../../charts/HorizontalBarChart'
import * as round from '../round'

export default {
  components: {
    FilterItems: () => import('@/components/shared/DateRangeFilter'),
    HorizontalBar,
    // Basic: () => import('./BasicDashboard'),
    // DoneFormsTable: ()=> import('@/components/forms/listing/DoneForm.vue'),
  },
  data() {
    return {
      date_range:[],
      chartData: {
        datasets: [
          {
            //bags
            data: [],
            //has N colors, fusion custom computed
            backgroundColor: '#9CCC65', 
            borderColor: [],
            borderWidth: 2,
            hoverBackgroundColor: [],
            label: 'Positivos',
          },
          {
            //goals
            data: [],
            //has N colors, fusion custom computed
            backgroundColor: '#FF5252', 
            // borderColor: [],
            // borderWidth: 2,
            // hoverBackgroundColor: [],
            label: 'Negativos',
          },
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [],
      },
      chartOptions:{
        cornerRadius: 15,
        scales: {
          yAxes: [{
            display: false,
            stacked: true,
            ticks: {
              mirror: false,
              autoSkip: false,
            },
            // barPercentage: 1,
          }],
          xAxes: [{
            stacked: true,
            barPercentage: 0.5,
            categoryPercentage: 1.0
          }],
        },
        legend:{
          display: true
        },
        tooltips: {
          enabled: true,
          mode: 'index',
          callbacks: {
            label: function(tooltipItems, data) { 
              //    // auto-comment// console.log({tooltipItems});
              //    // auto-comment// console.log({data});
              // data.datasets[tooltipItems.datasetIndex].label
              return  data.datasets[tooltipItems.datasetIndex].label+ ': ' + tooltipItems.xLabel + " itens";
            },
          }
        },
        plugins: {
          datalabels: {
            display: function(ctx){
              //    // auto-comment// console.log({ctx});
              
              return ctx.dataset.label.includes("Pos")? true : false
            },
            align: 'end',
            anchor: 'start',
            color: '#000',
            font: {
              weight: 'bold',
              size: 11,
            },
            formatter: function(value, context) {
              return context.chart.data.labels[context.dataIndex]
            }
          }
        }
      },
      chart_ready: false,
      oneForm: [],
      gradient: ['#f72047', '#1feaea'],

      headers_data: [
        {align: 'center', text: 'Data', value: 'done_at', width: '20%'},
        {align: 'center', text: 'Pontos', value: 'score', width: '20%'},
        {align: 'center', text: 'Usuário', value: 'user_name', width: '20%'},
        {align: 'center', text: 'Ação', value: 'action', width: '20%', sortable:false},
      ]
    }
  },
  methods: {
    formatDate(d){
         // auto-comment// console.log({d});
      
      if (!d) return null


      const [year, month, day] = d.substring(0,11).split('-')
      return `${day}/${month}/${year}`
    },
    loadChart(){
      this.chart_ready = false
      this.chartData.datasets[1].data = [] 
      this.chartData.datasets[0].data = []
      this.chartData.labels = []

      this.chartData.datasets[0].data = [...this.oneForm.items.map(ans => ans.total_ok)] // , ...this.oneForm.items.map(ans => ans.total_ok+2),...this.oneForm.items.map(ans => ans.total_ok+2)]
      this.chartData.datasets[1].data = [...this.oneForm.items.map(ans => -ans.total_nok)] //, ...this.oneForm.items.map(ans => -ans.total_nok-2),...this.oneForm.items.map(ans => -ans.total_nok-2)]
      this.chartData.labels = [...this.oneForm.items.map(ans => ans.title)] //,...this.oneForm.items.map(ans => `${ans.title} - 2`),...this.oneForm.items.map(ans => `${ans.title} - 3`)]

      setTimeout(() => {
        this.chart_ready = true
      }, 1200);
    },
    getOneDoneForm(filter) {
      Api.Dashboard.show(this.$route.params.id, filter)
        .then(response =>response.data)
        .then(dash=>{
          this.oneForm = dash
          this.loadChart()
        })
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    comp_date_range(){
      if (this.date_range){
        let d_pt = this.date_range.map(o=>this.formatDate(o))
        d_pt = d_pt.join(' ~ ')
        return d_pt
      }
    },
    ...mapState({
      solutionID: state=>state.Solution.solutionID,
      // data: state=> state.Module.state_var
    }),
    ...mapGetters({
      dateStartEnd: 'DateFilter/getStartEndDate',
    })
  },
  created () {
    this.getOneDoneForm(this.dateStartEnd)
  },
  watch: {
    solutionID(nv,ov) {
      if (nv){
        Api.Dashboard.index({solution_id: nv})
          .then(response =>response.data)
          .then(dash=>{
            this.allDoneFomrs = dash
          })
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>